export const NoteTemplate = {
  flow: 'x',
  gap: 'Z',
  flexWrap: 'wrap',
  padding: 'Z',

  children: [
    { templateName: 'Extraction' },
    { templateName: 'Root Canal' },
    { templateName: 'Crown Prep' },
    { templateName: 'Perio Maintenance' },
    { templateName: 'Exam' },
    { templateName: 'Emergency' }
  ],
  childrenAs: 'state',
  childExtends: 'NoteTemplatePill'
}

export const NoteTemplatePill = {
  tag: 'span',
  text: (el, s) => s.templateName,
  padding: 'Y A',
  round: 'C',
  fontSize: 'Z',
  fontWeight: '600',
  background: 'teal.1',
  color: 'teal',
  cursor: 'pointer',
  transition: 'background 0.15s',
  ':hover': { background: 'teal.2' },
  onClick: (el, s) => {
    const root = s.root || s
    root.update({ templateType: s.templateName })
  }
}
